import { render } from "./ShareableProfilePage.vue?vue&type=template&id=9582f80a&ts=true"
import script from "./ShareableProfilePage.vue?vue&type=script&lang=ts"
export * from "./ShareableProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__